(() => {
  const setup = () => {
    const main = document.querySelector('.cc-main-product');
    const details = document.querySelector('[id$="__details"].cc-product-details');
    const content = details?.querySelector(':scope > .container');
    if (!main || !details || !content) return;
    const ids = ['33dbfeae-7d0f-480f-a039-942de91b443d', 'bf_seasonal_faq', 'bf_product_faqs', 'bf_payment_details'];
    const sections = ids.map(id => document.querySelector('.shopify-section[id$="__' + id + '"]'));
    const originals = [details, ...sections.filter(Boolean)].map(element => {
      const marker = document.createComment('product-layout-position');
      element.before(marker);
      return { element, marker };
    });
    const desktop = window.matchMedia('(min-width: 769px)');
    const arrange = () => {
      if (desktop.matches) {
        main.after(details);
        const [trust, seasonal, faq, payment] = sections;
        if (seasonal) content.prepend(seasonal);
        if (trust) content.prepend(trust);
        if (faq) content.append(faq);
        if (payment) content.append(payment);
        details.classList.add('bf-original-desktop-flow');
      } else {
        details.classList.remove('bf-original-desktop-flow');
        originals.forEach(({ element, marker }) => marker.after(element));
      }
      window.dispatchEvent(new Event('resize'));
    };
    arrange();
    desktop.addEventListener('change', arrange);
    if ('ResizeObserver' in window) {
      new ResizeObserver(() => window.dispatchEvent(new Event('resize'))).observe(content);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
})();
